"use client";
import { getCustomerApi } from "@/services";
import { useChainId, useSendTransaction } from 'wagmi';
import { Hex } from 'viem' 
import { useEffect, useState } from "react";
import { message } from "@/components";
const customerApi = getCustomerApi()
export const useClaim = () => {
  const [claiming, setClaiming] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const { data: hash, sendTransaction } = useSendTransaction()
  const chainId = useChainId();
  const onClaim = async (token: string) => {
    setClaiming(true);
    const res = await customerApi.wallets.claimToken(token);
    console.log("line42", res);
    if(!res?.data.success) {
      console.log("error", res?.data.msgKey);
      message({
        content:'Oops...Something went wrong. Please try again.',
        className:'message-error'
      })
      setClaiming(false);
      return;
    }
    const claimData = res.data.obj;
    const to = claimData?.target_address as `0x${string}` 
    const value = claimData.call_data as Hex
    sendTransaction({to, data: value})
  }

  const sync = async ()=> {
    const result = await customerApi.tx.sync({tx_hash: hash, chain_id: chainId.toString() });
    console.log("line23", result);
    setClaiming(false);
    if(!result?.data.success) {
      console.log("error", result?.data.msgKey);
      message({
        content:'Oops...Something went wrong. Please try again.',
        className:'message-error'
      })
    } else {
      setIsSuccess(true);
    }
  }

  useEffect(() => {
    console.log("line28", hash);
    !!hash && sync()
  }, [hash])
  

  return {
    onClaim,
    hash,
    claiming,
    isSuccess,
    setIsSuccess
  }
}